"use strict";

require("core-js/modules/es.symbol.description.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.some.js");
require("core-js/modules/esnext.iterator.for-each.js");
require("core-js/modules/esnext.iterator.filter.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class EventDispatcher {
  constructor() {
    this._listeners = [];
  }
  hasEventListener(type, subtype, listener) {
    return this._listeners.some(item => item.type === type && item.subtype === subtype && item.listener === listener);
  }
  addEventListener(type, subtype, listener) {
    if (!this.hasEventListener(type, subtype, listener)) {
      this._listeners.push({
        type,
        subtype,
        listener,
        options: {
          once: false
        }
      });
    }
    return this;
  }
  removeEventListener(type, subtype, listener) {
    const index = this._listeners.findIndex(item => item.type === type && item.subtype === subtype && item.listener === listener);
    if (index >= 0) this._listeners.splice(index, 1);
    return this;
  }
  removeEventListenerBasedOnType(type, listener) {
    const index = this._listeners.findIndex(item => item.type === type && item.listener === listener);
    if (index >= 0) this._listeners.splice(index, 1);
    return this;
  }
  removeEventListeners() {
    this._listeners = [];
    return this;
  }
  dispatchEvent(evt) {
    const event = _objectSpread(_objectSpread({}, evt), {}, {
      subtype: ""
    });
    this._listeners.filter(item => item.type === evt.type).forEach(item => {
      const {
        type,
        listener,
        options: {
          once
        }
      } = item;
      listener.call(this, event);
      if (once === true) this.removeEventListenerBasedOnType(type, listener);
    });
    return this;
  }
}
var _default = exports.default = EventDispatcher;